export default function isDomainMatch(domain, hostname) {
  if ( domain === hostname ) {
    return true
  }

  const pattern = new RegExp(`^(?:.+?\\.)*?${ domain }$`)

  return pattern.test(hostname)
}
